import { cloneDeep } from "lodash-es";
import { ref, UnwrapRef } from "vue";
import { apiCall } from "@/core/api";
import REQUEST_TYPE from "@/core/api/request-types";

export interface OrganizationRole {
  active: boolean;
  createdAt: Date;
  createdBy: any;
  default: boolean;
  deleted: boolean;
  id: string;
  modifiedBy: any;
  organization: any;
  role: any;
  updatedAt: Date;
  user: any;
}

export const organizationRoles = ref(new Array<OrganizationRole>());

export const selectedOrganizationRole = ref<OrganizationRole>();

export async function getOrganizationRoles(
  userId: string,
  retryAuth = true
): Promise<boolean> {
  const resource = `/organization-role/user/${userId}`;
  const response = await apiCall(
    "GET",
    resource,
    undefined,
    REQUEST_TYPE.STANDART,
    undefined,
    !retryAuth
  );

  if (response.code === 200) {
    organizationRoles.value = response.result;
    selectedOrganizationRole.value = findDefaultOrganization();
    return true;
  }
  return false;
}

export function findDefaultOrganization(): OrganizationRole {
  // OT-4895: only consider org-roles whose organization still exists. A deleted
  // organization leaves an orphaned org-role (organization == null); selecting it
  // would crash the header on render.
  const validRoles = organizationRoles.value.filter(
    (item) => item && item.organization
  );
  let selectedItem;
  validRoles.forEach((item) => {
    if (item.default) {
      selectedItem = item;
    }
  });
  if (!selectedItem && validRoles.length > 0) {
    // eslint-disable-next-line prefer-destructuring
    selectedItem = validRoles[0];
  }
  return selectedItem;
}

export async function changeOrganizationRole(
  organizationRole: OrganizationRole
): Promise<any> {
  let result = false;
  if (organizationRole.organization.id && organizationRole.role.id) {
    await apiCall("POST", "/organization-role/update", organizationRole).then(
      (response) => {
        if (response.code === 200) {
          selectedOrganizationRole.value = cloneDeep(organizationRole);
          result = true;
        }
      }
    );
  }
  return result;
}

export function findOrganizationRoleByOrgId(
  organizationId: string
): UnwrapRef<OrganizationRole> {
  return organizationRoles.value.find(
    (obj) => obj.organization.id === organizationId
  );
}
